import React from 'react'
import { Paper } from '../../../components/common/Containers'
import Typography from '../../../components/common/Typography'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden',
    marginBottom: theme.spacing(4),
  },
  headerWrapper: {
    padding: '1.25rem 1.5rem 0',
  },
  header: {
    borderBottom: '3px solid #24466d',
    paddingBottom: theme.spacing(2),
    flexWrap: 'nowrap',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
  titleWrapper: {
    minWidth: 0,
  },
  title: {
    letterSpacing: '0.08em',
    whiteSpace: 'nowrap',
  },
}))

const Card = ({ title, icon, children }) => {
  const styles = useStyles()

  return (
    <Paper className={styles.root}>
      <div className={styles.headerWrapper}>
        <Grid container alignItems="center" className={styles.header}>
          {icon && (
            <Grid item className={styles.icon}>
              {icon}
            </Grid>
          )}

          <Grid item className={styles.titleWrapper}>
            <Typography
              variant="h4"
              weight="600"
              fontFamily="lexend"
              className={styles.title}
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
      </div>

      {children}
    </Paper>
  )
}

export default Card